import React, { useId, useRef, useState, useEffect } from "react";
import './faq.css'

const FaqItem = ({ idx, isOpen, onToggle, q, a, groupId }) => {
  const btnId = `${groupId}-trigger-${idx}`;
  const panelId = `${groupId}-panel-${idx}`;
  const panelRef = useRef(null);

  useEffect(() => {
    const panel = panelRef.current;
    if (!panel) return;
    const content = panel.firstElementChild;
    if (!content) return;

    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) {
      panel.style.maxHeight = isOpen ? "none" : "0px";
      panel.style.opacity = isOpen ? "1" : "0";
      return;
    }

    const target = isOpen ? content.scrollHeight : 0;
    panel.style.maxHeight = `${target}px`;
    panel.style.opacity = isOpen ? "1" : "0";
  }, [isOpen]);

  return (
    <div className="faq-card">
      <button
        id={btnId}
        className="faq-trigger"
        aria-expanded={isOpen}
        aria-controls={panelId}
        onClick={onToggle}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            onToggle();
          }
        }}
      >
        <span className="faq-q">{q}</span>
        <span className={`faq-icon ${isOpen ? "open" : ""}`} aria-hidden="true">
          <svg width="22" height="22" viewBox="0 0 24 24">
            <rect x="4" y="11" width="16" height="2" rx="1"></rect>
            <rect className="vbar" x="11" y="4" width="2" height="16" rx="1"></rect>
          </svg>
        </span>
      </button>

      <div
        id={panelId}
        className="faq-panel"
        role="region"
        aria-labelledby={btnId}
        ref={panelRef}
      >
        <div className="faq-content">{a}</div>
      </div>
    </div>
  );
};

export default function FAQ() {
  const uid = useId().replace(/:/g, "");
  const [openIndex, setOpenIndex] = useState(null);

  // ✅ Your FAQ data (edit freely)
  const items = [
    {
      q: "Do you offer a bond-back guarantee?",
      a: "Yes — subject to normal wear & tear. If your agent flags anything within 72 hours, we re-visit."
    },
    {
      q: "What’s included in End of Lease cleaning?",
      a: "Deep kitchen (oven + rangehood), bathrooms, skirting, cobwebs, window sills, floors, wardrobes & drawers."
    },
    {
      q: "Do you bring your own supplies?",
      a: "We bring professional equipment and eco-friendly chemicals — no extra cost."
    },
    {
      q: "Do you offer steam carpet cleaning?",
      a: "Yes. Add-on or standalone. We use hot water extraction for deep results."
    },
    {
      q: "Which areas do you serve?",
      a: "We proudly serve Sunshine VIC 3020, Werribee VIC 3030, Melbourne VIC 3004, Parkville VIC 3052, Truganina VIC 3029, Point Cook VIC 3030, Hoppers Crossing VIC 3029, and Williams Landing VIC 3027. We service all Melbourne Western suburbs."
    },
    {
      q: "How do you price jobs?",
      a: "Fixed, upfront quotes based on property size and condition. No hidden charges."
    },
    {
      q: "Can I book for the same day?",
      a: "Subject to availability. Call or WhatsApp and we’ll try our best to accommodate."
    },
    {
      q: "What payment methods do you accept?",
      a: "Cash, card, or bank transfer on completion unless otherwise agreed."
    }
  ];

  const toggle = (i) => setOpenIndex((prev) => (prev === i ? null : i));

  return (
    <section className="faq-wrap" aria-label="Frequently Asked Questions">
        <div className="section-title" >
            <h3 className="title" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">FAQ</h3>
            <h2 className="sub-title" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">Frequently Asked Questions</h2>
        </div>
      <div className="faq-grid" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
        {items.map((item, i) => (
          <FaqItem
            key={i}
            idx={i}
            q={item.q}
            a={item.a}
            isOpen={openIndex === i}
            onToggle={() => toggle(i)}
            groupId={uid}
            data-aos="fade-up"            // ✅ kebab-case
            data-aos-delay={i * 120}      // stagger
            data-aos-duration="700"
            data-aos-easing="ease-out"
          />
        ))}
      </div>
    </section>
  );
}
